import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const AuthAction = () => {
	const location = useLocation()
	const navigate = useNavigate()

	useEffect(() => {
		const params = new URLSearchParams(location.search)
		const mode = params.get('mode')
		const oobCode = params.get('oobCode')

		if (mode === 'resetPassword' && oobCode) {
			navigate(`/reset-password/?oobCode=${oobCode}`, { replace: true })
		} else {
			navigate('/', { replace: true })
		}
	}, [location, navigate])

	return null
}

export default AuthAction
